import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/pl';
import { lazy, Suspense } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Footer from './components/bars/Footer';
import NavBar from './components/bars/NavBar';
import { ConfirmEnrollment } from './components/enrollment/Confirm';
import { Enroll } from './components/enrollment/Enroll';
import LoginForm from './components/login/LoginForm';
import { LogoutPage } from './components/logout/Logout';
import { NotFoundPage } from './components/notFound/NotFoundPage';
import { Regulations } from './components/regulations/Regulations';
import { Result } from './components/result/Result';
import { Schedule } from './components/schedule/Schedule';
import { TournamentViewer } from './components/tournaments/TournamentsViewer';
import { PasswordReset } from './components/user/PasswordReset';
import { Profile } from './components/user/Profile';
import { ApiKeyProvider } from './contexts/ApiKeyContext';
import { SelectedTournamentProvider } from './contexts/SelectedTournamentContext';
import { ThreadsProvider } from './contexts/ThreadsContext';

dayjs.locale({
  ...dayjs.Ls['pl'], // Extend the existing Polish locale
  weekStart: 1, // 1 means Monday
});

const Teams = lazy(() => import('./components/creator/Teams'));
const TournamentEditor = lazy(() => import('./components/editors/TournamentEditor'));
const Referee = lazy(() => import('./components/referee/Referee'));
const Communicator = lazy(() => import('./components/messaging/Communicator'));
const Users = lazy(() => import('./components/users/Users'));

function App() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pl">
        <ApiKeyProvider>
          <ThreadsProvider>
            <SelectedTournamentProvider>
              <Router>
                <NavBar />
                <div style={{ flex: 1, padding: 10 }}>
                  <Suspense fallback={<div>Ładowanie...</div>}>
                    <Routes>
                      <Route path="/" element={<TournamentViewer />} />
                      <Route path="/start" element={<TournamentViewer />} />
                      <Route path="/login" element={<LoginForm />} />
                      <Route path="/logout" element={<LogoutPage />} />
                      <Route path="/profile" element={<Profile />} />
                      <Route path="/users" element={<Users />} />
                      <Route path="reset-password" element={<PasswordReset />} />
                      <Route path="/teams" element={<Teams />} />
                      <Route path="/edit-tournament/:tournamentId" element={<TournamentEditor />} />
                      <Route path="/tournament/:tournamentId/result" element={<Result />} />
                      <Route path="/tournament/:tournamentId/schedule" element={<Schedule />} />
                      <Route path="/tournament/:tournamentId/regulations" element={<Regulations />} />
                      <Route path="/tournament/:tournamentId/enroll" element={<Enroll />} />
                      <Route path="/confirm-enroll" element={<ConfirmEnrollment />} />
                      <Route path="/tournament/:tournamentId/team/:teamId/schedule/" element={<Schedule />} />
                      <Route path="/tournament/:tournamentId/phase/:phaseId/team/:teamId/schedule/" element={<Schedule />} />
                      <Route path="/match/:matchId/referee" element={<Referee />} />
                      <Route path="/messages" element={<Communicator />} />
                      <Route path="/messages/:threadId" element={<Communicator />} />
                      <Route path="*" element={<NotFoundPage />} />
                    </Routes>
                  </Suspense>
                </div>
                <Footer />
              </Router>
            </SelectedTournamentProvider>
          </ThreadsProvider>
        </ApiKeyProvider>
      </LocalizationProvider>
    </div>
  );
}

export default App;
